/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';

const ArrLeftButton = (props) => (
    <div className="boxBtn-inner">
        <div className={`ico-left ${!!props.className ? props.className : ''}`}></div>
    </div>
);

export default ArrLeftButton;



// WEBPACK FOOTER //
// ./src/browser/components/buttons/ArrLeftButton.js